import React, { Fragment, useCallback, useEffect, useState } from 'react';
import EntryRequestsView from '../Views/EntryRequestsView';
import {
  useFetchEntryReq,
} from '../../../../hooks/entryRequests';
import EntryRequestCreateContainer from './EntryRequestCreateContainer';
import EntryRequestDetailContainer from './EntryRequestDetailContainer';
import { ModalType, useFormikEntryFilters } from '../../../../utils';
import { EntryFilter, EntryRequest } from '../../types';
import { useEntryStates } from '../../../../share';
import { useAtom } from 'jotai';
import { authAtom } from '../../../../state';
import { useCancelRequest } from '../../../../hooks';
import { useCustomToast } from '../../../../components';

const EntryRequestsContainer: React.FC = () => {
  const { mutateAsync: cancelRequest } = useCancelRequest();
  const [itemSelected, setItemSelected] = useState<EntryRequest>();
  const [loadingData, setLoadingData] = useState<boolean>(true);

  const { showToast } = useCustomToast();

  const [modalState, setModalState] = useState<{
    type: ModalType;
    entryId?: string;
  }>({ type: null, entryId: undefined });

  const [authData] = useAtom(authAtom);
  const [filter, setFilter] = React.useState<EntryFilter>({
    requester_id: authData?.user.id,
  });
  const {
    data: entries,
    isPending: loadList,
    refetch,
  } = useFetchEntryReq(filter || {});

  const { data: entryStates } = useEntryStates();
  const handleModalToggle = (type: ModalType, id?: string) => {
    setModalState((prev) => ({
      type: prev.type === type ? null : type,
      entryId: id,
    }));
  };

  const handlePagination = (page: number) => {
    setFilter({
      ...filter,
      page: page.toString(),
    });
  };

  const handleFilter = useCallback(
    (values: Partial<EntryFilter>) => {
      setFilter({
        ...values,
        requester_id: authData?.user.id,
        created_at: values.created_at
          ? new Date(values.created_at).toISOString().split('T')[0]
          : '',
      });
    },
    [authData?.user.id]
  );

  const onCancelRequest = async (
    id: string,
    observations: string,
  ) => {
    try {
      await cancelRequest({ id, data: { reason: observations } });
      refetch();
    } catch (error) {
      showToast('error', 'Error al anular solicitud.');
    }
  };

  const formik = useFormikEntryFilters({ onSubmit: handleFilter });

  useEffect(() => {
    if (refetch) {
      refetch();
    }
  }, [filter, refetch]);

  return (
    <Fragment>
      {!loadList && (
        <EntryRequestCreateContainer
          isOpen={modalState.type === 'create'}
          OnClose={() => handleModalToggle('create')}
          setLoadingData={setLoadingData}
        />
      )}
      <EntryRequestDetailContainer
        isOpen={modalState.type === 'detail'}
        OnClose={() => handleModalToggle('detail')}
        data={itemSelected}
        isLoading={loadList}
        refetch={refetch}
        isApproveRequest={false}
        id={modalState.entryId}
      />

      <EntryRequestsView
        isLoading={loadList}
        data={entries}
        states={entryStates}
        formik={formik}
        onViewCreate={() => handleModalToggle('create')}
        onViewDetail={(itemSelected: any) => {
          setModalState({
            type: 'detail',
            entryId: itemSelected.id,
          })
          setItemSelected(itemSelected)
        }}
        onPagination={handlePagination}
        onResetFilters={() => {
          handleFilter({});
          formik.resetForm();
        }}
        onCancelRequest={(id, observations) => onCancelRequest(id, observations)}
        loadingData={loadingData}
      />
    </Fragment>
  );
};

export default EntryRequestsContainer;
